const forTheRecord = {
    path: 'forTheRecord',
    component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/yftAlipay/found/forTheRecord'], resolve)
}

export default forTheRecord